import { z } from "zod";

import { SelfServDataGenShape, SelfServMetaGenShape } from "@aa/wire";

/**
 * Self-serv render-data wire schemas; see design/wiki/wire-schemas.md.
 *
 * These validate the two reads on the render path consumed by
 * {@link SelfServDataService}: SelfServMeta (from `/api/selfserv/meta`) and
 * SelfServData (from the render blob at `meta.dataUrl`). The nested render-node
 * bases (SelfServQuestion / SelfServSnippet / ...) are folded into
 * SelfServDataGenShape and need no separate facade.
 */
export const SelfServDataWireSchema =
  SelfServDataGenShape.describe("SelfServData");

export const SelfServMetaWireSchema =
  SelfServMetaGenShape.describe("SelfServMeta");

export type SelfServDataWire = z.infer<typeof SelfServDataGenShape>;

export type SelfServMetaWire = z.infer<typeof SelfServMetaGenShape>;
